export default "__VITE_ASSET__zP65_ZGH__"